import { API_ROUTES } from '@/constants/apiRoutes';
import { AuthorizedTeammateListResponse } from '@/types/authorizedTeammates';
import { api } from '@/utils/api';

export const getAuthorizedTeammatesListService = async (
  queryParams: string,
) => {
  const { data } = await api<AuthorizedTeammateListResponse>({
    url: `${API_ROUTES.AUTHORIZED_TEAMMATES}?${queryParams}`,
    method: 'get',
    version: 2,
  });

  return data;
};
